import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import messages_en from './translations/messages_en.json';
import messages_fr from './translations/messages_fr.json';
import { baseUrl } from './agent';

i18n
  .use(detector)
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      // first get available translations from the back end
      loadPath: `${baseUrl}/translations/{{lng}}`,
    },
    fallbackLng: 'en',
    load: 'languageOnly',
    preload: ['en', 'fr'],
    keySeparator: false, // we do not use keys in form messages.welcome
    nsSeparator: false, // allows colon (:) character in keys, otherwise it tries to split them
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: { useSuspense: false },
  });

// after initialization, get available translations from front end
i18n.on('initialized', options => {
  i18n.addResourceBundle('en', 'translation', messages_en);
  i18n.addResourceBundle('fr', 'translation', messages_fr);
});

export default i18n;
